// utils/scheduleEmail.js
import { apiRefresh } from "../services/api"; // adjust this import

export const scheduleEmail = async ({
  showAttachmentsData = [],
  to = "",
  ccc = "",
  bcc = "",
  subject = "",
  letterString = "",
  selectedBranchName = "",
  emailId = "",
  scheduleOn = new Date().toISOString(),
}) => {
  try {
    const attachmentsArr = showAttachmentsData.map((attachment) => ({
      url: "",
      type: attachment.type,
      name: attachment.name,
      blobURL: attachment.url,
    }));

    const toEmails = to
      .split(";")
      .filter((email) => email.trim())
      .map((email) => ({ type: "TO", name: email.trim() }));

    const ccEmails = ccc
      .split(";")
      .filter((email) => email.trim())
      .map((email) => ({ type: "CC", name: email.trim() }));

    const bccEmails = bcc
      .split(";")
      .filter((email) => email.trim())
      .map((email) => ({ type: "BCC", name: email.trim() }));

    const schEmail = {
      emails: [
        {
          message: letterString,
          subject: subject || "",
          status: "",
          from: selectedBranchName,
          priority: 0,
          attachments: attachmentsArr,
          recipients: [...toEmails, ...ccEmails, ...bccEmails],
          frequencyCode: "",
          moduleId: "10",
          emailId,
          scheduleOn,
        },
      ],
    };

    const schEmailOpt = {
      url: `v1/email/SenScheduleEmail`,
      types: ["SCHEDULE_EMAIL_SUCCESS", "SCHEDULE_EMAIL_FAILURE"],
    };

    const response = await apiRefresh.post(schEmailOpt, schEmail);
    return response; // You can return this to check status
  } catch (error) {
    console.error("Email scheduling failed:", error);
    throw error;
  }
};
